<template>
    <GroupPriceDiscountInput v-for="(discount, index) of model" :key="index" :model-value="discount" :title="getTitle(index)" :validator="validator" @update:model-value="setDiscount(index, $event)">
        <template v-if="index === model.length - 1" #right>
            <button v-if="index > 0" class="button icon trash small" type="button" @click="deleteDiscount(index)" />
            <button class="button icon add small" type="button" @click="addDiscount" />
        </template>
    </GroupPriceDiscountInput>
</template>

<script setup lang="ts">
import type { Group } from '@stamhoofd/structures';
import { GroupPriceDiscount } from '@stamhoofd/structures';
import { watch } from 'vue';
import type { Validator } from '../../errors/Validator';
import GroupPriceDiscountInput from './GroupPriceDiscountInput.vue';

withDefaults(
    defineProps<{

        /**
         * Helps to determine if reduced prices are enabled or not
         */
        group?: Group | null;
        validator: Validator | null;
    }>(),
    {
        group: null,
    },
);
const model = defineModel<GroupPriceDiscount[]>({ required: true });

/**
 * Assert to always have at least one item in the array
 */
watch(model, (value) => {
    if (value.length === 0) {
        model.value = [GroupPriceDiscount.create({})];
    }
}, { immediate: true });

function addDiscount() {
    model.value = [...model.value, model.value[model.value.length - 1]?.clone() ?? GroupPriceDiscount.create({})];
}

function deleteDiscount(index: number) {
    if (model.value.length <= 1) {
        return;
    }
    const array = [...model.value];
    array.splice(index, 1);
    model.value = array;
}

function setDiscount(index: number, discount: GroupPriceDiscount) {
    model.value = model.value.map((d, i) => {
        if (i === index) {
            return discount;
        }
        return d;
    });
}

function getTitle(index: number) {
    if (index === model.value.length - 1) {
        return $t('%16k', { index: index + 2 });
    }
    return $t('%16l', { index: index + 2 });
}

</script>
